import { BiSolidCameraPlus, BiBuildings, BiLogoMicrosoft, BiSolidBaguette, BiSolidBuildings } from "react-icons/bi";
import {
    BsBoxFill, BsFillPersonPlusFill, BsCameraVideoFill,
    BsCameraFill, BsFillKeyFill, BsFillFileEarmarkZipFill, BsFillImageFill,
    BsQuestionCircleFill, BsBoxArrowRight, BsFillPostcardFill,
    BsClipboard2PlusFill, BsFillPeopleFill, BsFillRocketTakeoffFill,
    BsPersonCircle,BsClockFill 
} from "react-icons/bs";
import { TbBrandWindowsFilled } from "react-icons/tb";
import { FaMicrosoft } from "react-icons/fa6";

// import Profile from "../pages/auth/Profile"
import Login from "../pages/auth/Login"
import Dashboard from "../pages/dashboard/Dashboard";
import Role from "../pages/permissions/Role"
import Profile from "../pages/auth/Profile";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import Payments from "../pages/portal/Payments";




export const anonyMenus = [
    {
        to: "/",
        component: <Login />,
    },
    {
        to: "/login/",
        component: <Login/>,
    },
    {
        to: "/forgot-password/",
        component: <ForgotPassword />,
    },
    {
        to: "/reset-password/",
        component: <ResetPassword />,
    },

]

export const menus = [

    {
        to: "/login/",
        component: <Login />,
        hide: true,
        hideSideBar: true,
        hideHeader: true
    },
    {
        icon: <BiLogoMicrosoft size={20} />,
        label: "Dashboard",
        to: "/",
        component: <Dashboard />,
    },
    {
        icon: <BiLogoMicrosoft size={20} />,
        label: "Dashboard",
        to: "/dashboard/",
        component: <Dashboard />,
        permission: "*"
    },

    {
        icon: <BsPersonCircle size={18} />,
        label: "My Profile",
        to: "/profile/",
        component: <Profile />,
        permission: "*",
    },


    {
        icon: <BsFillPeopleFill size={20} />,
        label: "Permissions",
        to: "/role/",
        component: <Role />,
        permission: "view_permission",
    },
     
   {
    icon: <BsPersonCircle size={18} />,
    label: "Payments",
    to: "/payments/",
    component: <Payments />,
    permission: "*",
},

    {
        icon: <BsQuestionCircleFill size={19} />,
        label: "Helps",
        to: "/help/",
        component: <></>,
        permission: "*",
    },
]